import { axios } from '@/services/axios';

const setCompanyDataStorageLocation = async (companyId, locationId) => {
    const res = await axios.put(
        `/Company/${companyId}/DataStorageLocation/${locationId}`,
    );
    return res.data;
};

export default setCompanyDataStorageLocation;
